module.exports = __webpack_public_path__ + "img/elux.egate.android.7df6aa6d.webp";